module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_edit_bg-2b2db5ce30dada264b4a940b790f9942.png";